// extracted by mini-css-extract-plugin
export default {"navbarWrapper":"SwitchTab_navbarWrapper__3Jvj-","navbar":"SwitchTab_navbar__oDDlH","navItem":"SwitchTab_navItem__Q+FrG","active":"SwitchTab_active__7Hj1y"};